import { isFeatureEnabled } from '@lumapps/features';
import { createSelector } from '@lumapps/redux/reselect';

import { ASK_AI_ALPHA_FF, ASK_AI_FF, ASK_LUMAPPS_FF } from '../constants';

/** Check whether the AskLumapps FF is enabled in the store */
export const isAskLumappsEnabled = isFeatureEnabled(ASK_LUMAPPS_FF);

/** Check whether the AskAI FF is enabled in the store */
export const isAskAIEnabled = isFeatureEnabled(ASK_AI_FF);

/** Check whether either AskAI or AskLumapps FF is enabled */
export const isAskAIorAskLumappsEnabled = createSelector(
    [isAskLumappsEnabled, isAskAIEnabled],
    (askLumappsEnabled, askAIEnabled) => {
        return Boolean(askLumappsEnabled || askAIEnabled);
    },
);

/** Check wether the AskAi alpha FF is enabled */
export const isAskAiAlphaEnabled = isFeatureEnabled(ASK_AI_ALPHA_FF);
